var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"AddingMenu"},[_c(_setup.AppButton,{attrs:{"disabled":_setup.addButtonFaster},on:{"onClick":_setup.onAddFaster}},[_vm._v("\n    Добавьте быстрее! \n    "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }